import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { InvoiceDownloadInput, InvoiceDownloadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = InvoiceDownloadInput;
type TData = InvoiceDownloadPayload;

export const useInvoiceDownload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation invoiceDownload($input: InvoiceDownloadInput!) {
      invoiceDownload(input: $input) {
        success
        downloadId
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
